import style from '../../Dashboard.module.scss';
import EntitySearch from './EntitySearch/EntitySearch';

export const Header = () => {
    return (
        <div className={style.dashboardHeader + ' flex w-full gap-2'}>
            <div className="flex-1 flex w-full justify-between">
                <div className="text-sf-white text-15 font-medium font-sf-poppins">
                    Silverfort Identity Security Platform
                </div>
                <div>
                    <EntitySearch />
                </div>
            </div>
        </div>
    );
};
